import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import StorageService from '../services/StorageService';
import axios from 'axios';
import { MdDone, MdClear, MdCreate } from 'react-icons/md';

class TimesheetForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: false,
      remarks: '',
      site: '',
      siteList: [],
      date: '',
      time: '',
    };
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  getSiteThermaList = (siteName, siteKey) => {
    const data = {
      sitekey: siteKey,
    };

    axios
      .post('https://zoidapi.pseudoscops.com:3005/v1/extapi/therma/site', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }

        if (result.data.length > 0) {
          this.setState({
            siteList: [
              ...this.state.siteList,
              { name: siteName, key: siteKey },
            ],
          });
        }
        //this.setState({ siteThermaList: result.data });
      })
      .catch(error => {
        alert(error);
      });
  };

  handleSubmit = event => {
    event.preventDefault();

    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
      PersonID: this.props.match.params.person,
      SiteKey: this.state.site,
      DateTime: this.state.date + ' ' + this.state.time + ':00',
      Data: JSON.stringify({
        mode: this.state.mode,
        remarks: this.state.remarks,
        user: user.email,
      }),
    };

    axios
      .post(url + ':3000/v1/person/createTimesheet', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'Timesheet created successfully.',
          'success',
          true,
        );
      })
      .catch(error => {
        alert(error);
      });
  };

  getSiteList = () => {
    for (let s of this.props.data.siteList) {
      this.getSiteThermaList(s.SiteName, s.SiteKey);
    }
  };

  componentDidMount() {
    this.getSiteList();
  }

  render() {
    return (
      <Form onSubmit={this.handleSubmit} className="AuthForm">
        <ModalHeader toggle={this.props.onToggleModal()}>Add Entry</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label for="mode">Mode</Label>
                <Input
                  type="select"
                  name="mode"
                  value={this.state.mode}
                  onChange={this.changeHandler}
                  required
                >
                  <option value=""></option>
                  <option value="Check In">Check In</option>
                  <option value="Check Out">Check Out</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label for="site">Site</Label>
                <Input
                  type="select"
                  name="site"
                  value={this.state.sitekey}
                  onChange={this.changeHandler}
                  required
                >
                  <option value=""></option>
                  {this.state.siteList.length > 0 &&
                    this.state.siteList.map((item, index) => {
                      return (
                        <option key={index} value={item.key}>
                          {item.name}
                        </option>
                      );
                    })}
                </Input>
              </FormGroup>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="date">Date</Label>
                    <Input
                      type="date"
                      name="date"
                      value={this.state.date}
                      onChange={this.changeHandler}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="time">Time</Label>
                    <Input
                      type="time"
                      name="time"
                      value={this.state.time}
                      onChange={this.changeHandler}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <FormGroup>
                <Label for="remarks">Remarks</Label>
                <Input
                  type="textarea"
                  name="remarks"
                  value={this.state.remarks}
                  onChange={this.changeHandler}
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Submit
          </Button>{' '}
        </ModalFooter>
      </Form>
    );
  }
}

export default TimesheetForm;
